import { createReducer, on, StoreModule } from '@ngrx/store';
import { SearchResult } from '@polaris-customerweb/sharedcomponents.search';
import {
    AppendSearchResults,
    CanSearchAgain,
    SearchAgain,
    SetActiveSearchResult,
    SetIsSearchActive,
    SetSearchQuery,
    SetSearchResults,
} from './search.actions';
export const searchFeatureKey = 'searchState';

export interface SearchState {
    canSearchAgain: boolean;
    searchAgain: boolean;
    searchResults: SearchResult[];
    activeSearchResult: SearchResult | undefined;
    searchIsActive: boolean;
    query: string;
}

const initialState: SearchState = {
    activeSearchResult: undefined,
    canSearchAgain: false,
    query: '',
    searchAgain: false,
    searchIsActive: false,
    searchResults: [],
};

export const searchReducer = createReducer(
    initialState,
    on(CanSearchAgain, (state, { canSearchAgain }) => {
        return { ...state, canSearchAgain };
    }),
    on(SearchAgain, (state, { searchAgain }) => {
        return { ...state, searchAgain };
    }),
    on(SetSearchResults, (state, { searchResults }) => {
        return { ...state, searchResults };
    }),
    on(AppendSearchResults, (state, { searchResults }) => {
        return {
            ...state,
            searchResults: [...state.searchResults, ...searchResults],
        };
    }),
    on(SetActiveSearchResult, (state, { activeSearchResult }) => {
        return { ...state, activeSearchResult };
    }),
    on(SetIsSearchActive, (state, { searchIsActive }) => {
        return { ...state, searchIsActive };
    }),
    on(SetSearchQuery, (state, { query }) => {
        return { ...state, query };
    })
);

export const searchStoreModule = StoreModule.forFeature(
    searchFeatureKey,
    searchReducer
);
